/** Valor de RULES.Condition para reglas sin condiciones / ejecución directa (#705). */
export const WXRL_DIRECT_CONDITION = 'DIRECT';

export function isDirectCondition(v: string | null | undefined): boolean {
  return !!v && String(v).trim().toUpperCase() === WXRL_DIRECT_CONDITION;
}
